import {
  Box,
  Center,
  Flex,
  Heading,
  Tab,
  TabList,
  Tabs,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Jobrole_component from "../../../Components/Recruiter/Jobrole_Modal/Jobrole_component.jsx";
import Navbar from "../../../Components/Recruiter/Navbar/Navbar.jsx";
import { postActions } from "../../../redux/actions/index.js";
import Post_newJob from "./Post_newJob.jsx";
import { Loader } from "../../../Components/Loader/Loader.js";
import { useNavigate } from "react-router-dom";
import { PostJobButton } from "Components/FloatButton/PostJobButton.jsx";
const Active_Tab = () => {
  const posts = useSelector((state) => state.post);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Get company data from local storage
  const user = JSON.parse(localStorage.getItem("user"));
  const companyId = user.companyId;
  const [playAnimation, setPlayAnimation] = useState();
  useEffect(() => {
    dispatch(postActions.getPosts(companyId, "active", setPlayAnimation));
  }, []);
  return (
    <>
      <div>
        <Navbar />
        {playAnimation ? (
          <Loader />
        ) : (
          <Box mx={[1, 1, 7, 7]} mt={[8, 8, 16, 16]}>
            <Box
              py={6}
              display={
                posts.total === 0
                  ? "none"
                  : "block"
                  ? ["none", "none", "block", "block"]
                  : ["none", "none", "block", "block"]
              }
            >
              <Heading
                textAlign="left"
                color="#544D5E"
                fontSize={[16,18,20,20,20,24,24]}
                fontWeight={550}
                fontFamily={"Epilogue"}
                ml={4}
                mt={4}
                mb={-10}
                // border={"1px solid red"}
              >
                Active Jobs
              </Heading>
            </Box>

            {/* Desktop */}

            <Center mt={10} display={["none", "none", "block", "block"]}>
              {posts?.total === 0 ? (
                playAnimation === false && <Post_newJob />
              ) : (
                <Wrap mt={-4}>
                  {posts.data.map((item, idx) => (
                    <WrapItem>
                      <Jobrole_component key={idx} data={item} />
                    </WrapItem>
                  ))}
                </Wrap>
              )}
            </Center>

            {/* Mobile */}

            <Center mt={4} display={["block", "block", "none", "none"]}>
              <Heading
                textAlign="left"
                color="#544D5E"
                fontSize={20}
                fontWeight={550}
                fontFamily={"Epilogue"}
                ml={2}
                mt={67}
                // border={"1px solid red"}
              >
                Job posts
              </Heading>
              <Tabs>
                <TabList>
                  <Tab
                    fontFamily={"Roboto"}
                    fontSize={16}
                    fontWeight={400}
                    onClick={() => navigate("/hiring/recruiter/active")}
                  >
                    Active
                  </Tab>
                  <Tab
                    fontFamily={"Roboto"}
                    fontSize={16}
                    fontWeight={400}
                    onClick={() => navigate("/hiring/recruiter/closed")}
                  >
                    Close
                  </Tab>
                  <Tab
                    fontFamily={"Roboto"}
                    fontSize={16}
                    fontWeight={400}
                    onClick={() => navigate("/hiring/recruiter/draft")}
                  >
                    Draft
                  </Tab>
                </TabList>
              </Tabs>
              {posts.total === 0 ? (
                <Post_newJob />
              ) : (
                <Center>
                  <Flex flexDir="column" overflowY="auto">
                    {posts.data.map((item, idx) => (
                      <Jobrole_component key={idx} data={item} />
                    ))}
                  </Flex>
                  <PostJobButton />
                </Center>
              )}
            </Center>
          </Box>
        )}
      </div>
    </>
  );
};
export default Active_Tab;
